import Immutable from 'immutable';
import {
  COURSE_MEMBERSHIPS_DATA_FETCH_SUCCESS,
  COURSE_MEMBERSHIP_DATA_FETCH_SUCCESS,
} from './actions';
import { LOGOUT_SUCCESS } from '../Auth/actions';

export function CourseMembership(state = Immutable.Map(), action) {
  switch (action.type) {
    case COURSE_MEMBERSHIPS_DATA_FETCH_SUCCESS: {
      let newState = state;
      action.data.forEach((courseMembership) => {
        newState = newState.set(
          courseMembership.coursePath,
          Immutable.fromJS(courseMembership)
        );
      });
      return newState;
    }
    case COURSE_MEMBERSHIP_DATA_FETCH_SUCCESS: {
      const { membership, coursePath } = action;
      return state.set(coursePath, Immutable.fromJS(membership));
    }
    case LOGOUT_SUCCESS: {
      return Immutable.Map();
    }
    default: {
      return state;
    }
  }
}
